import { useState } from 'react';
import { useIntl } from 'react-intl';

import { USA_POSTAL_CODE_EXAMPLES } from '../../constants';
import { INSURANCE_ELIGIBILITY_FIELDS_TYPES } from '../../constants/formFields';

import DOBValidator from '../../utils/validations/DOBValidator';
import phoneValidator from '../../utils/validations/homePhoneValidator';
import postalCodeValidator from '../../utils/validations/postalCodeValidator';
import isDateNotBeforeMinValidator from '../../utils/validations/isDateNotBeforeMinValidator';

const {
  PRIMARY_SUBSCRIBER,
  PHONE_NUMBER,
  POSTAL_CODE,
  DOB,
} = INSURANCE_ELIGIBILITY_FIELDS_TYPES;

const useValidatePatientInsuranceForm = () => {
  const { formatMessage } = useIntl();

  const [formErrors, setFormErrors] = useState({});

  const validateFormFields = formState => {
    const errors = {};

    if (!formState[PRIMARY_SUBSCRIBER]) {
      if (!postalCodeValidator(formState[POSTAL_CODE])) {
        errors.postalCode = formatMessage(
          {
            id: 'errors.validation.profile.postalCode.format',
          },
          { example: USA_POSTAL_CODE_EXAMPLES },
        );
      }

      if (!phoneValidator(formState[PHONE_NUMBER])) {
        errors.phoneNumber = formatMessage({
          id: 'errors.validation.profile.phoneHome.format',
        });
      }

      if (!DOBValidator(formState[DOB])) {
        errors.dob = formatMessage({
          id: 'errors.validation.profile.dob.format',
        });
      }

      if (!isDateNotBeforeMinValidator(formState[DOB])) {
        errors.dob = formatMessage({
          id: 'errors.validation.profile.dob.minDate',
        });
      }
    }

    setFormErrors(errors);

    return { isValid: !(Object.keys(errors).length > 0), errors };
  };

  return { formErrors, setFormErrors, validateFormFields };
};

export default useValidatePatientInsuranceForm;



// WEBPACK FOOTER //
// ./src/hooks/patientInsurance/useValidatePatientInsuranceForm.js